export const CashPaymentDescription = ({ deliveryMethod }) => (
  <>
    <div className="inputLabel">Pago en la entrega</div>
    <div className="pt-1">
      {deliveryMethod?.nameHomeDelivery
        ? "Se pagará al recibir el pedido en tu domicilio"
        : deliveryMethod?.nameStoreDelivery
        ? "Se pagará al recoger el pedido en tienda"
        : "Se pagará al recibir el pedido"}
    </div>
  </>
);
